import React from 'react'
import './NotificationsCard.scss'

import clsx from 'clsx'
import moment from 'moment'

const NotificationsCard = ({ data, getUsers }) => {
  const { createdAt, id, is_all, message, title, users } = data

  const [state] = React.useState({
    showMore: false,
    showReviews: false,
    showProStatusControls: false,
    loading: false,
  })

  const { showMore } = state

  return (
    <>
      <li className={clsx('PROsCard', showMore && 'PROsCard-active')}>
        <div className='PROsCard__top'>
          <div className='PROsCard__topBlock'>
            {moment(createdAt).format('MM/DD/YYYY')}
          </div>
          <div className='PROsCard__topBlock'>{message}</div>
          <div className='PROsCard__topBlock'>
            {is_all ? 'Yes' : 'No'}
          </div>
        </div>
      </li>
    </>
  )
}

export default NotificationsCard
